var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "sip-row-actions sip-row-actions--icons",
      class: { "is-open": _vm.open },
      attrs: { "data-sip-vue": "1" },
    },
    [
      _vm.canView
        ? _c(
            "button",
            {
              staticClass: "sip-row-actions__icon-btn",
              attrs: {
                type: "button",
                "aria-label": _vm.trans("general.view"),
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onView.apply(null, arguments)
                },
              },
            },
            [
              _c("admin-icon", {
                staticClass: "sip-row-actions__glyph",
                attrs: { name: "file-search", size: 16 },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "sip-row-actions__btn-label" }, [
                _vm._v(_vm._s(_vm.trans("general.view"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canEdit
        ? _c(
            "button",
            {
              staticClass: "sip-row-actions__icon-btn",
              attrs: {
                type: "button",
                "aria-label": _vm.trans("general.edit"),
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onEdit.apply(null, arguments)
                },
              },
            },
            [
              _c("admin-icon", {
                staticClass: "sip-row-actions__glyph",
                attrs: { name: "pencil", size: 16 },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "sip-row-actions__btn-label" }, [
                _vm._v(_vm._s(_vm.trans("general.edit"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.canDelete && _vm.deleteConfirm
        ? _c(
            "button",
            {
              directives: [
                {
                  name: "confirm",
                  rawName: "v-confirm",
                  value: _vm.deleteConfirm,
                  expression: "deleteConfirm",
                },
              ],
              key: _vm.deleteKey || "delete",
              staticClass: "sip-row-actions__icon-btn is-danger",
              attrs: {
                type: "button",
                "aria-label": _vm.trans("general.delete"),
              },
            },
            [
              _c("admin-icon", {
                staticClass: "sip-row-actions__glyph",
                attrs: { name: "trash", size: 16 },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "sip-row-actions__btn-label" }, [
                _vm._v(_vm._s(_vm.trans("general.delete"))),
              ]),
            ],
            1
          )
        : _vm.canDelete
        ? _c(
            "button",
            {
              staticClass: "sip-row-actions__icon-btn is-danger",
              attrs: {
                type: "button",
                "aria-label": _vm.trans("general.delete"),
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.onDelete.apply(null, arguments)
                },
              },
            },
            [
              _c("admin-icon", {
                staticClass: "sip-row-actions__glyph",
                attrs: { name: "trash", size: 16 },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "sip-row-actions__btn-label" }, [
                _vm._v(_vm._s(_vm.trans("general.delete"))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.hasOverflow
        ? _c("div", { staticClass: "sip-row-actions__more" }, [
            _c(
              "button",
              {
                ref: "toggle",
                staticClass:
                  "sip-row-actions__icon-btn sip-row-actions__more-btn",
                attrs: {
                  id: _vm.triggerId,
                  type: "button",
                  "aria-label": _vm.moreLabel,
                  "aria-haspopup": "menu",
                  "aria-expanded": _vm.open ? "true" : "false",
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.onToggle.apply(null, arguments)
                  },
                },
              },
              [
                _c("admin-icon", {
                  staticClass: "sip-row-actions__glyph",
                  attrs: { name: "more-horizontal", size: 16 },
                }),
                _vm._v(" "),
                _c("span", { staticClass: "sip-row-actions__btn-label" }, [
                  _vm._v(_vm._s(_vm.moreLabel)),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "menu",
                staticClass: "sip-row-actions__menu",
                class: { "is-open": _vm.open },
                attrs: { role: "menu", "aria-labelledby": _vm.triggerId },
                on: {
                  "!click": function ($event) {
                    return _vm.onMenuClick.apply(null, arguments)
                  },
                },
              },
              [
                _vm._t("before"),
                _vm._v(" "),
                _vm._t("default"),
                _vm._v(" "),
                _vm._t("after"),
              ],
              2
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }